import { useReactFlow, Node } from '@xyflow/react'
import { useCallback } from 'react'

export const uuid = (name: string): string =>
  `${name}_${new Date().getTime().toString(36)}`

export function useCreateRandomSequenceAutomationPoCNode() {
  const { screenToFlowPosition, setNodes, getNodes } = useReactFlow()

  const createRandomSequenceAutomationPoCNode = useCallback(
    (data: Node['data']) => {
      // Create a unique id for the annotation node
      const randomSequenceAutomationPoCNodeId = uuid(
        data.nodetype || 'randomsequence'
      )

      const newNodePosition2 = screenToFlowPosition({
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
      })

      // Create the annotation node
      const randomSequenceAutomationPoCNode: Node = {
        id: randomSequenceAutomationPoCNodeId,
        position: {
          x: newNodePosition2.x,
          y: newNodePosition2.y,
        },
        measured: { width: 273, height: 76 },
        type: 'randomsequencenode', // Assuming the type is 'randomSequenceAutomationPoCNode'
        data: data,
      }

      // Add the new annotation node
      setNodes(
        // Check if nodes is an array before concatenating
        [...getNodes(), randomSequenceAutomationPoCNode]
      )

      return { node: randomSequenceAutomationPoCNode }
    },
    [setNodes, getNodes, screenToFlowPosition]
  )

  return createRandomSequenceAutomationPoCNode
}

export default useCreateRandomSequenceAutomationPoCNode
